import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { CARDS_PAGE_PATH } from "../../App";
import PageHeader from "../../components/PageHeader/PageHeader";
import PageFooter from "../../components/PageFooter/PageFooter";
import '../CardsPage/CardsPage.styles.scss';
import './NewIntroPage.styles.scss';
import {AppContext} from '../../App.js';

function IntroPage() {
    const { setIsCardsPageBeenShown } = useContext(AppContext);
    const [currentIntroInx, setCurrentIntroInx] = useState(+sessionStorage.getItem('currentIntroInx') || 1);
    const [currentCirclesInx, setCurrentCirclesInx] = useState(0);

    useEffect(() => {
        sessionStorage.setItem('currentIntroInx', `${currentIntroInx}`);
    }, [currentIntroInx]);

    useEffect(() => {
        setIsCardsPageBeenShown(false);
    }, []);

    useEffect(() => {
        const lines = [
            document.getElementById('line0'),
            document.getElementById('line1'),
            document.getElementById('line2'),
            document.getElementById('line3'),
        ];
        const timeStampMove = [1000, 3500, 5000, 6000];

        function step(timestamp) {
            const points = ['', '', '', '', ''];
            for (let x = 0; x <= 150; x++) {
                lines.forEach(
                    (line, i) => {
                        const y = (10 * Math.sin((timeStampMove[i] + timestamp) / 5000)) * Math.sin(0.05 * (x + 5 * i)) + 40;
                        points[i] += `${x},${y}${x === 150 ? '' : ','}`
                    }
                );
            }
            lines.forEach((line, i) => line.setAttribute('points', points[i]));
            requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }, []);

    const handleNextBtnClick = () => {
        setCurrentCirclesInx(currentCirclesInx === 4 ? (4) : (currentCirclesInx + 1));
    };

    return (
        <>
            <PageHeader/>
            <div className="intro-page">
                <svg
                    viewBox="0 0 150 80"
                    id="canvas"
                    className="intro-page__lines"
                >
                    <g>
                        <polyline id="line0" viewBox="0 0 150 80"/>
                        <polyline id="line1" viewBox="0 0 150 80"/>
                        <polyline id="line2" viewBox="0 0 150 80"/>
                        <polyline id="line3" viewBox="0 0 150 80"/>
                    </g>
                </svg>
                {currentIntroInx === 1 && (
                    <div className="intro-page__start-bg">
                        <div className="intro-page__start">
                            <div className="intro-page__subtitle">
                                The consumer
                            </div>
                            <div className="intro-page__title">
                                food journey<sup>SM</sup>
                            </div>
                            <div className="intro-page__button">
                                <button
                                    className="btn btn--primary"
                                    onClick={() => setCurrentIntroInx(2)}
                                >
                                    start
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {currentIntroInx === 2 && (
                    <>
                        <div className="intro-page__inner">
                            <div className="inner">
                                {currentCirclesInx === 0 && (
                                    <div className={`intro-page__remarks`}>
                                        <div className="intro-page__remark-top">People make eating decisions based on a nuanced
                                            sequence of interrelated factors
                                        </div>
                                        <div className="intro-page__remark">We call this pathway
                                            the <span>CONSUMER FOOD JOURNEY <sup>SM</sup></span></div>
                                    </div>
                                )}
                                <div className="intro-page__content">
                                    {currentCirclesInx === 1 && (
                                        <>
                                            <div className="intro-page__circle-text">
                                                {`TRIGGERS start the food journey.`}
                                            </div>
                                            <div className="intro-page__circle-text">
                                                {`Hunger, cravings, and even boredom often catalyze our decision to eat.`}
                                            </div>
                                        </>
                                    )}
                                    {currentCirclesInx === 2 && (
                                        <>
                                            <div className="intro-page__circle-text">
                                                {`OCCASIONS define the scenario faced by the consumer.`}
                                            </div>
                                            <div className="intro-page__circle-text">
                                                {`Will it be a quick bite, a formal meal, or something else entirely?`}
                                            </div>
                                        </>
                                    )}
                                    {currentCirclesInx === 3 && (
                                        <>
                                            <div className="intro-page__circle-text">
                                                {`What NEEDS is the consumer looking to satisfy?`}
                                            </div>
                                            <div className="intro-page__circle-text">
                                                {`Are they focused on health, customization, indulgence, or something else?`}
                                            </div>
                                        </>
                                    )}
                                    {currentCirclesInx === 4 && (
                                        <>
                                            <div className="intro-page__circle-text">
                                                {`With all this in mind, the consumer makes a DECISION –`}
                                            </div>
                                            <div className="intro-page__circle-text">
                                                {`where to eat, what to have, how to get it, and more.`}
                                            </div>
                                        </>
                                    )}
                                    <div
                                        className={`intro-page__circles intro-page__circles--${currentCirclesInx === 0 ? 'hidden' : 'visible'}`}>
                                        <div
                                            className={`intro-page__circle circle circle-1 circle-1--${currentCirclesInx}`}>
                                            <div
                                                className={`CategoryTile ${currentCirclesInx === 1 ? 'CategoryTile--active' : ''}`}>
                                                <img
                                                    className="CategoryTile__img"
                                                    src={`${process.env.REACT_APP_BASE_ROUTE}thumb-categories/3.png`}
                                                    alt=""
                                                />
                                                <div className="CategoryTile__title">Triggers</div>
                                                <div className="CategoryTile__number">1</div>
                                            </div>
                                        </div>
                                        <div
                                            className={`intro-page__circle circle circle-2 circle-2--${currentCirclesInx}`}>
                                            <div
                                                className={`CategoryTile ${currentCirclesInx === 2 ? 'CategoryTile--active' : ''}`}>
                                                <img
                                                    className="CategoryTile__img"
                                                    src={`${process.env.REACT_APP_BASE_ROUTE}thumb-categories/2.png`}
                                                    alt=""
                                                />
                                                <div className="CategoryTile__title">Occasions</div>
                                                <div className="CategoryTile__number">2</div>
                                            </div>
                                        </div>
                                        <div
                                            className={`intro-page__circle circle circle-3 circle-3--${currentCirclesInx}`}>
                                            <div
                                                className={`CategoryTile ${currentCirclesInx === 3 ? 'CategoryTile--active' : ''}`}>
                                                <img
                                                    className="CategoryTile__img"
                                                    src={`${process.env.REACT_APP_BASE_ROUTE}thumb-categories/4.png`}
                                                    alt=""
                                                />
                                                <div className="CategoryTile__title">Needs</div>
                                                <div className="CategoryTile__number">3</div>
                                            </div>
                                        </div>
                                        <div
                                            className={`intro-page__circle circle circle-4 circle-4--${currentCirclesInx}`}>
                                            <div
                                                className={`
                                                CategoryTile
                                                CategoryTile--wide
                                                ${currentCirclesInx === 4 ? 'CategoryTile--active' : ''}
                                            `}>
                                                <img
                                                    className="CategoryTile__img"
                                                    src={`${process.env.REACT_APP_BASE_ROUTE}thumb-categories/1.png`}
                                                    alt=""
                                                />
                                                <div className="CategoryTile__title">The decision</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {currentCirclesInx >= 0 && currentCirclesInx < 4 && (
                            <div className={`intro-page__btns ${currentCirclesInx === 0 ? 'intro-page__btns--remarks' : ''}`}>
                                <Link
                                    className="btn btn--secondary"
                                    to={`${CARDS_PAGE_PATH}/triggers`}
                                >
                                    Skip intro
                                </Link>
                                <button
                                    className="intro-page__btn btn btn--primary"
                                    onClick={() => handleNextBtnClick()}
                                >
                                    next
                                </button>
                            </div>
                        )}
                        {currentCirclesInx === 4 && (
                            <div className={`intro-page__btns ${currentCirclesInx === 0 ? 'intro-page__btns--remarks' : ''}`}>
                                <Link
                                    to={`${CARDS_PAGE_PATH}/triggers`}
                                    className="btn btn--primary"
                                >
                                    explore
                                </Link>
                            </div>
                        )}
                    </>
                )}
                <PageFooter/>
            </div>
        </>
    );
}

export default IntroPage;